var _defs, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg20097037261582967227(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2e79bd;}.cls-2{fill:#2d3e50;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "b") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.29462,107.68647a1.95175,1.95175,0,0,0-2.70375.52021,6.33612,6.33612,0,1,1-8.79717-8.79641,1.94851,1.94851,0,0,0-2.18459-3.22713A10.23237,10.23237,0,1,0,31.817,110.3905a1.94839,1.94839,0,0,0-.52237-2.704Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M72.80439,49.13545A26.52514,26.52514,0,0,0,38.5855,51.92252L23.19085,67.31717,8.34949,69.2585l-5.456,5.456,50.392,50.39195,5.456-5.456,1.94129-14.84132L76.07741,89.41448a26.52532,26.52532,0,0,0,2.78707-34.21893A24.02805,24.02805,0,0,0,72.80439,49.13545Zm-15.473,7.44949a13.99422,13.99422,0,0,0-9.95921,4.12431l-4.5636,4.5636a2.23286,2.23286,0,1,1-3.15774-3.15774l4.5636-4.5636A18.42131,18.42131,0,0,1,57.33144,52.1202a2.23237,2.23237,0,1,1,0,4.46474Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M121.96551,6.03049a10.69081,10.69081,0,0,0-15.254.1256A270.34277,270.34277,0,0,0,75.90105,44.08417c.107.06979.21868.1442.32566.22326A29.96708,29.96708,0,0,1,83.69323,51.774c.07906.107.14885.214.2233.32562a270.9442,270.9442,0,0,0,37.92808-30.81043A10.69228,10.69228,0,0,0,121.96551,6.03049Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg20097037261582967227);
export default __webpack_public_path__ + "static/media/20097037261582967227.245da52c.svg";
export { ForwardRef as ReactComponent };